import React from 'react';
import { Container, Accordion, Row, Col } from 'react-bootstrap';
import { FaBook, FaCalendarAlt, FaChartLine, FaEnvelope, FaBell, FaExclamationTriangle } from 'react-icons/fa';
import {
  PageContainer,
  PageHeader,
  InfoCard,
  AccordionScenario,
  AnimatedSection,
  accordionStyles
} from '../../../components/SharedComponents';

const scenarios = [
  {
    id: 1,
    icon: <FaBook />,
    title: 'W odpowiedzi na argument "Ważna praca/Potrzebne ręce do pracy"',
    color: '#667eea',
    argument: 'Zostań dzisiaj, mamy ważny projekt i brakuje rąk. Szkoła może poczekać, to jest ważniejsze.',
    response: 'Rozumiem, że firma ma pilne potrzeby, ale moja obecność w szkole jest obowiązkowa i stanowi podstawowy cel mojej umowy o pracę w celu przygotowania zawodowego. Czas na zajęcia szkolne jest wliczany do mojego czasu pracy (na podstawie Kodeksu pracy) i mam obowiązek w nich uczestniczyć. Nieobecność generuje zaległości, co zagraża mojej promocji. Proszę o niezwłoczne oddelegowanie mnie do szkoły zgodnie z ustalonym harmonogramem.'
  },
  {
    id: 2,
    icon: <FaCalendarAlt />,
    title: 'W odpowiedzi na próbę jednostronnej zmiany grafiku na stałe',
    color: '#f093fb',
    argument: 'Zmienimy grafik i będziesz przychodzić do pracy w dni szkolne, a szkołę nadrobisz później.',
    response: 'Uprzejmie przypominam, że nie mam możliwości samodzielnego \'nadrabiania\' zajęć szkolnych. Mój czas pracy, zgodnie z przepisami, obejmuje czas nauki. Jako pracownik młodociany, pracodawca jest zobowiązany umożliwić mi udział w zajęciach szkolnych i nie może jednostronnie i notorycznie tego zmieniać. Proszę o przestrzeganie uzgodnionego planu zajęć, abym mógł/mogła wywiązać się zarówno z obowiązków zawodowych, jak i szkolnych.'
  },
  {
    id: 3,
    icon: <FaChartLine />,
    title: 'W odpowiedzi na groźbę złej oceny w pracy lub karę',
    color: '#4facfe',
    argument: 'Jeśli pójdziesz teraz do szkoły, obniżę Ci ocenę na praktykach i będę musiał/a Cię ukarać za brak zaangażowania.',
    response: 'Moje zaangażowanie jest wysokie w dni, w których jestem oddelegowany/a do pracy. Natomiast odmowa umożliwienia mi realizacji obowiązku szkolnego jest naruszeniem mojego prawa, a nie brakiem zaangażowania. Nie mogę ryzykować niezdania do następnej klasy z powodu zaległości. Żadne kary nałożone w związku z wypełnianiem obowiązków szkolnych nie będą miały podstawy prawnej. Muszę iść na zajęcia, ponieważ to jest moje prawo i obowiązek.'
  },
  {
    id: 4,
    icon: <FaEnvelope />,
    title: 'Formalna odpowiedź pisemna (przy powtarzającej się sytuacji)',
    color: '#43e97b',
    argument: 'Pracodawca komunikuje telefonicznie lub ustnie, że masz zostać, mimo dnia szkolnego.',
    response: 'Szanowny/a Panie/Pani [Nazwisko],\nPotwierdzam, że dziś, [data], powinienem/powinnam zostać oddelegowany/a do [nazwa szkoły/placówki edukacyjnej] w celu uczestnictwa w zajęciach szkolnych. Zgodnie z Art. 202 Kodeksu pracy, czas nauki jest wliczany do mojego czasu pracy.\nProszę o formalne oddelegowanie mnie na zajęcia, ponieważ notoryczne nieobecności w szkole stwarzają zagrożenie niedostatecznymi ocenami i niepowodzeniem w procesie przygotowania zawodowego.\nLiczę na Pana/Pani zrozumienie i przestrzeganie przepisów dotyczących obowiązku dokształcania się młodocianych.'
  },
  {
    id: 5,
    icon: <FaBell />,
    title: 'W przypadku ciągłego ignorowania i konieczności eskalacji',
    color: '#f5576c',
    argument: 'Pracodawca ignoruje wszystkie prośby, a Ty czujesz, że musisz iść do szkoły.',
    response: 'Pomimo Pana/Pani próśb, muszę w tej chwili opuścić stanowisko pracy i udać się na zajęcia szkolne. Obowiązek dokształcania się jest nadrzędny w stosunku do pracy i w przypadku pracownika młodocianego musi być bezwzględnie realizowany.'
  }
];

const WorkAndSchool = () => {
  return (
    <PageContainer>
      <Container>
        <style>{accordionStyles}</style>
        
        <PageHeader 
          title="Praca a szkoła"
          subtitle="Wzory rozmów o dostosowaniu grafiku do nauki"
        />

        <Row className="justify-content-center">
          <Col xs={12} lg={10}>
            <AnimatedSection>
              <InfoCard>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  Jako pracownik młodociany masz prawo i obowiązek uczęszczania do szkoły. Czas na zajęcia szkolne 
                  jest wliczany do czasu pracy (Art. 202 Kodeksu pracy). Pracodawca musi umożliwić Ci realizację 
                  obowiązku szkolnego. Poniżej znajdziesz gotowe szablony odpowiedzi.
                </p>
              </InfoCard>
            </AnimatedSection>

            <Accordion alwaysOpen>
              {scenarios.map((scenario, index) => (
                <AccordionScenario
                  key={scenario.id}
                  scenario={scenario}
                  index={index}
                  eventKey={String(index)}
                  argumentLabel="Argumentacja/Sytuacja pracodawcy"
                  responseLabel="Asertywna odpowiedź"
                />
              ))}
            </Accordion>

            <AnimatedSection delay={0.6} className="mt-4">
              <InfoCard
                gradient="rgba(255, 0, 0, 0.1)"
                borderColor="rgba(255, 0, 0, 0.3)"
                icon={<FaExclamationTriangle style={{ color: '#ff0000' }} />}
                title="Pamiętaj"
              >
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6', color: 'rgba(255,255,255,0.9)' }}>
                  Pracodawca, który notorycznie zatrzymuje pracownika młodocianego na praktykach w dni, kiedy powinien 
                  on uczestniczyć w zajęciach szkolnych, łamie podstawowy cel umowy o pracę w celu przygotowania 
                  zawodowego oraz narusza przepisy Kodeksu pracy.
                </p>
              </InfoCard>
            </AnimatedSection>
          </Col>
        </Row>
      </Container>
    </PageContainer>
  );
};

export default WorkAndSchool;